<div class="settings-modal-dialog__wrapper">
  <div class="settings-modal-dialog__top">
    <div mat-dialog-title>
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <i class="fal fa-cog i-16 mr-4"></i>
          <span>{{title}}</span>
        </div>
        <div *ngIf="showClose">
          <button trgButton class="dialog-close-btn" (click)="close()">
            <i class="fal fa-times i-12 p-relative ot-1"></i>
          </button>
        </div>
      </div>
    </div>
    <div mat-dialog-content class="text-center">
      <div class="settings-modal__tab-headers" [hidden]="tabs.length < 2">
        <div class="settings-modal__tab-header" *ngFor="let tab of tabs; index as index" [class.active]="index === activeTabIndex" (click)="setActiveTab(index)">
          <div>
            <i *ngIf="tab.icon" class="{{tab.icon}} mr-6"></i>
            <span class="fs-14 bold">{{tab.title}}</span>
          </div>
        </div>
      </div>
      <div class="settings-modal__tab-contents">
        <div class="settings-modal__tab-content" *ngFor="let tab of tabs; index as index" [class.active]="index === activeTabIndex">
          <ng-container *ngIf="tab.contentIsTemplateRef; else HTMLContent">
            <ng-container *ngTemplateOutlet="tab.content"></ng-container>
          </ng-container>
          <ng-template #HTMLContent>
            <div [innerHTML]="tab.content"></div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions align="end" class="settings-modal-dialog__bottom">
    <button trgButton color="outline" class="min-w-70" (click)="close()">Close</button>
    <button *ngIf="canSave" trgButton color="primary" class="min-w-80" (click)="close(true)" [disabled]="!(valid$ | async)">Save</button>
  </div>
</div>
